import React from 'react';
import { openDialog } from '../../dialogs/dialogs';
import { ConflictingBetsSelection, ConflictingBetsSelectionProps } from './ConflictingBetsSelection';
import { nuiCtx, NuiPlatform } from '../../../common/initialization';
import { LastCmdError } from '../types';
import { clearLastCmdError } from './handlers';
import { dispatch } from 'nike-re-framejs';

export function openConflictingBetsDialog(cmdError: LastCmdError) {
    const { NuiDialog } = nuiCtx.components;
    const clearError = () => {
        dispatch(clearLastCmdError(nuiCtx.platform as NuiPlatform));
    };
    openDialog(
        {
            name: 'nui/betslip/conflicting-bets',
            component: ({ cmdError, close }: ConflictingBetsSelectionProps) => (
                <NuiDialog name="nui/betslip/conflicting-bets" className={'br-radius-sm'} onClose={clearError}>
                    <ConflictingBetsSelection cmdError={cmdError} close={close} />
                </NuiDialog>
            )
        },
        {
            cmdError
        } as ConflictingBetsSelectionProps
    );
}
